import React from 'react';

const InventoryItem = ({ artwork, onDragStart, getOptimizedImageUrl, audioMap }) => {
  const hasAudio = audioMap && audioMap[artwork.vc_id];
  const isAccepted = artwork.accepted === true;
  const isPending = artwork.accepted === false;
  // Handle drag start
  const handleDragStart = (e) => {
    // Use lower quality for drag operation
    const thumbEl = e.currentTarget.querySelector('.inventory-thumb');
    if (thumbEl) {
      thumbEl.style.backgroundImage = `url(${getOptimizedImageUrl(artwork.source, 'drag')})`;
    }
    onDragStart(e, artwork);
  };
  
  // Handle drag end
  const handleDragEnd = (e) => {
    // Restore thumbnail quality
    const thumbEl = e.currentTarget.querySelector('.inventory-thumb');
    if (thumbEl) {
      thumbEl.style.backgroundImage = `url(${getOptimizedImageUrl(artwork.source, 'thumbnail')})`;
    }
  };
  
  return (
    <div 
      className="inventory-item"
      draggable
      data-id={artwork.element_id}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      {/* Thumbnail with optimized image */}
      <div className="inventory-thumb-container">
        <div 
          className="inventory-thumb"
          style={{ backgroundImage: `url(${getOptimizedImageUrl(artwork.source, 'thumbnail')})` }}
        />
        {hasAudio && (
          <div className="audio-indicator" title="Has Audio Story">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 14v-4a9 9 0 0 1 18 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 14a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h3zM3 14a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        )}
        {isAccepted && (
          <div 
            className="accepted-indicator" 
            title="Accepted"
            style={{
              position: 'absolute',
              bottom: '2px',
              left: '2px',
              backgroundColor: '#10b981',
              color: 'white',
              fontSize: '8px',
              fontWeight: '600',
              padding: '1px 4px',
              borderRadius: '3px',
              textTransform: 'uppercase',
              letterSpacing: '0.02em'
            }}
          >
            ✓
          </div>
        )}
        {isPending && (
          <div 
            className="pending-indicator" 
            title="Pending Approval"
            style={{
              position: 'absolute',
              bottom: '2px',
              left: '2px',
              backgroundColor: '#f59e0b',
              color: 'white',
              fontSize: '8px',
              fontWeight: '600',
              padding: '1px 4px',
              borderRadius: '3px',
              textTransform: 'uppercase',
              letterSpacing: '0.02em'
            }}
          >
            ?
          </div>
        )}
      </div>
      
      {/* Artwork info */}
      <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
        {artwork.title && (
          <div style={{ 
            fontSize: '11px', 
            fontWeight: '500',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {artwork.title}
          </div>
        )}
        <div className="font-medium" style={{ fontSize: artwork.title ? '10px' : '12px', color: artwork.title ? '#6b7280' : 'inherit' }}>
          {artwork.vc_id || `Artwork ${artwork.element_id}`}
        </div>
        <div className="text-xs text-gray-500">
          {artwork.width}" × {artwork.height}"
        </div>
      </div>
    </div>
  );
};

export default InventoryItem;